import React, {useEffect} from "react";
import {Button, Form, Input, message} from "antd";
import {useModel, useModelDispatchers} from "../../../models";
import {OptType} from "./dictModel";

const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 16,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};
export default function () {
    const [form] = Form.useForm();

    const [
        {optType, selectNode, selectPNode},
        {setOptType, setSelectNode, setSelectPNode, insertDict, updateDict, loadID}
    ] = useModel("dict");
    const {closeNav} = useModelDispatchers("nav");
    useEffect(() => {
        form.resetFields();
        if (optType === OptType.ADD_ROOT) {
            form.setFieldsValue({
                pCode: null,
            });
        } else if (optType === OptType.ADD_SAME_LEVEL) {
            form.setFieldsValue({
                pCode: selectPNode ? selectPNode.title : ""
            });
        } else if (optType === OptType.ADD_CHILD_LEVEL) {
            form.setFieldsValue({
                pCode: selectNode ? selectNode.title : "",
            });
        } else if (optType === OptType.DETAIL) {
            form.setFieldsValue({
                pCode: selectPNode ? selectPNode.title : "",
                dictCode: selectNode ? selectNode.key : "",
                dictName: selectNode ? selectNode.title : "",
                dictDesc: selectNode ? selectNode.dictDesc : "",
            });
        }

    }, [optType, selectNode, selectPNode]);
    const addDict = (data) => {
        insertDict(data).then(id => {
            form.setFieldsValue({dictCode: id})
        })
    }
    const onFinish = () => {
        // const formStore = form.getFieldsValue();
        // return console.log(formStore)
        if (optType === OptType.DETAIL) {
            form.validateFields().then(data => {
                // console.log(data)
                // let {pCode,dictCode,dictName,dictDesc} = data
                let {dictCode, pcode, id} = selectNode
                let datas = {//这里pCode是无用参数
                    ...data,
                    dictCode,
                    pcode,
                    id
                }
                updateDict(datas)
            })
        } else {
            form.validateFields().then(data => {
                if (optType === OptType.ADD_ROOT) {
                    let datas = {
                        ...data,
                        pcode: null
                    }
                    addDict(datas)
                } else if (optType === OptType.ADD_SAME_LEVEL) {
                    let {pcode, dictCode} = selectNode

                    let datas = {
                        ...data,
                        pcode
                    }

                    addDict(datas)
                } else if (optType === OptType.ADD_CHILD_LEVEL) {
                    let {pcode, dictCode} = selectNode

                    let datas = {
                        ...data,
                        pcode: dictCode
                    }
                    addDict(datas)
                }
            })
        }

    }
    const onReset = () => {
        setOptType(OptType.ADD_ROOT);
        setSelectNode(null);
        setSelectPNode(null);
        form.resetFields();
        message.success('重置字典成功!', 10);
    }
    const onClose = () => {
        closeNav();
    }

    const onGenerateId = async () => {
        let pid = await loadID();
        form.setFieldsValue({
            dictCode: pid,
        });
    }
    return (
        <Form {...layout} form={form} name="control-hooks">
            <Form.Item name="pCode" label="父级字典">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="dictCode" label="编号">
                {/*{optType === OptType.DETAIL ? <Input disabled={true}/> : <Input disabled={true} addonAfter={
                    <Button type="link" htmlType="button" onClick={onGenerateId} className="margin-left-8">
                        获取
                    </Button>
                }/>}*/}
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="dictName" label="名称" rules={[{required: true, message: '名称字段是必输项',}]}>
                <Input/>
                {/* disabled={optType === OptType.DETAIL} */}
            </Form.Item>
            <Form.Item name="dictDesc" label="备注" rules={[{required: false}]}>
                <Input.TextArea/>
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" disabled={optType === OptType.DETAIL} htmlType="button" onClick={onFinish}>
                    {optType === OptType.DETAIL ? "修改" : "添加"}
                </Button>
                <Button htmlType="button" onClick={onReset} className="margin-left-8">
                    重置
                </Button>
                <Button type="link" htmlType="button" onClick={onClose} className="margin-left-8">
                    返回
                </Button>
            </Form.Item>
        </Form>
    )
};